import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {useSelector} from 'react-redux';
import type {RootState} from '@/config/store';
import {STELLAR_WIDGET_SCRIPT_URL} from '@/utils/envvars';

export const StellarWidget: React.FC = () => {
    const minimalToken = useSelector((state: RootState) => state.logins.minimalToken);

    useEffect(() => {
        if (!minimalToken) return;

        const SRC = STELLAR_WIDGET_SCRIPT_URL.trim();
        if (!SRC) return;

        const SCRIPT_ID = 'stellar-widget-script';

        const appendScript = (src: string, id: string) => {
            const s = document.createElement('script');
            s.id = id;
            s.src = src;
            s.async = true;
            // s.crossOrigin = 'anonymous'; // <-- AÑADIR ESTO
            document.head.appendChild(s);
            return s;
        };

        const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;

        if (!existing) {
            appendScript(SRC, SCRIPT_ID);
        } else {
            // si ya existe (se cargó antes que el div), forzamos re-ejecución
            // añadiendo un script con cache-bust. Esto hará que el widget
            // vuelva a inicializarse buscando el #stellar-widget.
            appendScript(`${SRC}?_=${Date.now()}`, `${SCRIPT_ID}-${Date.now()}`);
        }

        // cleanup opcional: al hacer logout/remover token borramos los scripts añadidos
        return () => {
            const scripts = Array.from(document.querySelectorAll(`script[id^="${SCRIPT_ID}"]`));
            scripts.forEach((s) => s.parentNode?.removeChild(s));
        };
    }, [minimalToken]);

    if (!minimalToken) return null;

    return createPortal(
        <div
            id="stellar-widget"
            data-zone="MAZ"
            data-vendor="YAYDOO"
            data-language="es"
            data-default-corner="bottom-right"
            data-token={minimalToken}
        />,
        document.body
    );
};

export default StellarWidget;
